module.exports = __webpack_public_path__ + "img/al5.1b2b3155.png";